
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $cf2f2ea6e1c0495a$exports = {};

$parcel$export($cf2f2ea6e1c0495a$exports, "spectrum-Image-img", () => $cf2f2ea6e1c0495a$export$3238177972e11200, (v) => $cf2f2ea6e1c0495a$export$3238177972e11200 = v);
var $cf2f2ea6e1c0495a$export$3238177972e11200;
$cf2f2ea6e1c0495a$export$3238177972e11200 = `tX8u6G_spectrum-Image-img`;


export {$cf2f2ea6e1c0495a$exports as default};
//# sourceMappingURL=image_vars_css.module.js.map
